import React from 'react';
import './Footer.css';

function Footer() {
    return(
        <>
        </>
);
};
export default Footer;